var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-page-wrapper"},[_c('title-section',{attrs:{"id":"mainSection"}}),_c('about-us-section',{attrs:{"id":"aboutSection"}}),_c('our-products-section',{attrs:{"id":"ourProductsSection"}}),_c('location-section',{attrs:{"id":"locationSection"}}),_c('feedback-form-section',{attrs:{"id":"feedbackFormSection"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }